export const trackingActionMap = {
	createOffer: "create_offer",
	deliver: "deliver_vehicle",
	detailVehicle: "inventory_vehicle_details",
	editMedia: "edit_media",
	editPricing: "edit_pricing",
	offerOverview: "offer_overview",
	openListing: "open_listing",
	openPFCLink: "open_pfc_link",
	openSaleDetails: "open_sale_details",
	printEnergyEfficiencyLabel: "print_eel",
	printExpose: "print_expose",
	printMonroneyLabel: "print_monroney_label",
	printPriceTag: "print_price_tag",
	printTyreDocuments: "print_tyre_labels",
	referralLink: "copy_referral_link",
	removeVehicle: "delete_vehicle",
	reportSale: "report_sale",
	reserveVehicle: "reserve_vehicle",
	sellVehicle: "sell_vehicle",
	transferVehicle: "transfer_vehicle",

	copyListingLink: "copy_listing_link",
	copyShareVehiclesLink: "copy_share_vehicles_link",
	openShareVehiclesLink: "open_share_vehicles_link",
	openShareVehiclesModal: "open_share_vehicles_modal",
}

export type ActionItemKey = keyof typeof trackingActionMap
